
export const getQueryParam = (v) => {
  const url = decodeURIComponent(v)
  const paramary = url.split('?')
  const data = {}
  if (paramary.length > 1) {
    const params = paramary[paramary.length - 1]
    const keyvalue = params.split('&')

    keyvalue.forEach(k => {
      const keyvalues = k.split('=')
      if (keyvalues.length) {
        data[keyvalues[0]] = keyvalues[1]
      }
    })
  }
  return data
}

export const isWeiXin = (v) => {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') > -1) {
    return true // 是微信端
  } else {
    return false
  }
}

export const isQQ = (v) => {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('qq') > -1) {
    return true // 是QQ端
  } else {
    return false
  }
}

export const isDingTalk = (v) => {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('dingtalk') > -1) {
    return true // 是钉钉
  } else {
    return false
  }
}

export const isMobile = (v) => {
  if ((window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    return true // 手机端
  } else {
    return false // alert('PC端')
  }
}

export const dateToString = (date) => {
  var year = date.getFullYear()
  var month = (date.getMonth() + 1).toString()
  var day = (date.getDate()).toString()
  if (month.length === 1) {
    month = '0' + month
  }
  if (day.length === 1) {
    day = '0' + day
  }
  var dateTime = year + '-' + month + '-' + day
  return dateTime
}

export const dateOnlyMonth = (date) => {
  var month = (date.getMonth() + 1).toString()
  if (month.length === 1) {
    month = '0' + month
  }
  return month
}
export const dateOnlyDate = (date) => {
  var day = (date.getDate()).toString()
  if (day.length === 1) {
    day = '0' + day
  }
  return day
}
// const pathToRegexp = require('path-to-regexp')

const Base64 = require('js-base64').Base64

export const getQueryString = (name) => {
  var preurl = location.href.split('?')[1] // 获取url中"?"符后的字串
  var url = preurl.split('#')[0]
  var theRequest = new Object()
  var str = url.substring(0)
  var strs = str.split('&')
  for (var i = 0; i < strs.length; i++) {
    theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
  }
  if (name === 'code') {
    return theRequest[name]
  } else {
     
    const params = Base64.decode(theRequest['state'])
    if (JSON.parse(params)) {
      return JSON.parse(params)[name]
    }
    return ''
  }
}

export const replaceUrl = () => {
  const url = document.location.href
  if (url.indexOf('?code=') >= 0) {
    const rangeU = url.indexOf('?code=')
    const rangeEnd = url.indexOf('#/')
    const urltop = url.substring(0, rangeU)
    const urlTail = url.substring(rangeEnd, url.length)
    const replaceurl = urltop + urlTail
    console.log(replaceurl)
    document.location = replaceurl
  }
}

// import api from '../api/collections.js'
import host from './config.js'

export const requestStatics = (res) => {
  // api.statistics(res).then(r => {
  //   console.error(r)
  // })
  navigator.sendBeacon(host.profile.host + '/adks-app/pc/apiv1/collection/addSave', res)
}
